import { Component } from '@angular/core';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})
export class StoreComponent {
english:boolean=true;
hindi:boolean=false;
ngOnInit(): void {
  const storeVal = localStorage.getItem('selectedValue');
  if (storeVal == 'english') {
    this.english = true;
    this.hindi = false;
  }
  if (storeVal == 'hindi') {

    this.english = false;
    this.hindi = true;
  }

}
}
